import { rem } from 'polished'
import styled from 'styled-components'
import NestableClickableListItem from 'LuxKit/List/NestableClickableListItem'

const TripPlanBrowseRow = styled(NestableClickableListItem)`
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  border-radius: ${props => props.theme.borderRadius.L};
  gap: ${rem(16)};

  &.size-medium {
    padding: ${rem(12)};
  }
`

export default TripPlanBrowseRow
